import { forwardRef } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export interface SpinnerPageProps {
  className?: string;
}

const Page = forwardRef<HTMLDivElement, SpinnerPageProps>(function Page(
  { className },
  ref
) {
  return (
    <div ref={ref} className={cn(css.page, className)}>
      <Root className={css.pageSpinner} />
    </div>
  );
});

export interface SpinnerProps {
  className?: string;
}

function Root({ className }: SpinnerProps) {
  return <span className={cn(css.spinner, className)} />;
}

export const Spinner = Object.assign(Root, {
  Page,
});
